import axios from 'axios'
import { getAuthorizedConfiguration } from '../helpers/RequestHelper'

export const IS_LOADING = 'IS_LOADING'
export const SET_ALL_DATA = 'SET_ALL_DATA'

export const IS_SAVING = 'IS_SAVING'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_DYNAMIC_FILTER_OPTIONS = 'SET_DYNAMIC_FILTER_OPTIONS'

/**
 * Is loading action
 */
export const isLoading = (status) => {
	return {
		type: IS_LOADING,
		status
	}
}

/**
 * Set all data action
 */
export const setAllData = (data) => {
	return {
		type: SET_ALL_DATA,
		data
	}
}

/**
 * Is saving
 */
export const isSaving = (status) => {
	return {
		type: IS_SAVING,
		status
	}
}

/**
 * Set filter options action
 */
export const setFilterOptions = (data) => {
	return {
		type: SET_FILTER_OPTIONS,
		data
	}
}

export const setDynamicFilterOptions = (field, data) => ({
	type: SET_DYNAMIC_FILTER_OPTIONS,
	field,
	data
})

export const loadAllCriticalComponentsDashboard = (filters) => {
	return function (dispatch, getState) {
		dispatch(isLoading(true))
		// Get the authorized configuration
		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let url = `${window.config.serviceManagementBackendUrl}/CriticalComponents`
		let command = {
			Years: filters?.year ?? [],
			Months: filters?.month ?? [],
			Models: filters?.model ?? [],
			Gaes: filters?.gae ?? [],
			Applicants: filters?.nomSol ?? [],
			MaterialPts: filters?.materialPt ?? [],
			Faults: filters?.fault ?? [],
			Failures: filters?.failure ?? [],
			CompletionDate: filters?.CompletionDate ?? ''
		}

		return axios
			.post(url, command, config)
			.then((serverResponse) => {
				dispatch(isLoading(false))
				if (serverResponse.status === 200) {
					dispatch(setAllData(serverResponse.data))
				}
				return Promise.resolve()
			})
			.catch((error) => {
				dispatch(isLoading(false))
				console.error('Error loading all Critical Components Dashboard', error)
				return Promise.reject(error.response.data.Message)
			})
	}
}

/**
 * Load filter options (years and models) for the filter panel
 */
export const loadCriticalComponentsFilterOptions = () => {
	return function (dispatch, getState) {
		dispatch(isLoading(true))
		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let url = `${window.config.serviceManagementBackendUrl}/CriticalComponents/FilterOptions`

		return axios
			.get(url, config)
			.then((serverResponse) => {
				dispatch(isLoading(false))
				if (serverResponse.status === 200) {
					dispatch(setFilterOptions(serverResponse.data))
				}
				return Promise.resolve(serverResponse.data)
			})
			.catch((error) => {
				dispatch(isLoading(false))
				console.error('Error loading Critical Components Filter Options', error)
				return Promise.reject(error.response?.data?.Message || error.message)
			})
	}
}

export const loadDynamicFilterOptions = (fieldName, columnDatabase, sqlSource) => {
	return function (dispatch, getState) {
		dispatch(isLoading(true))
		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let url = `${window.config.serviceManagementBackendUrl}/CriticalComponents/DynamicFilterOptions`
		const request = {
			FieldName: fieldName,
			ColumnDatabase: columnDatabase,
			SqlSource: sqlSource
		}
		return axios
			.post(url, request, config)
			.then((serverResponse) => {
				dispatch(isLoading(false))
				if (serverResponse.status === 200) {
					dispatch(setDynamicFilterOptions(fieldName, serverResponse.data))
				}
				return Promise.resolve(serverResponse.data)
			})
			.catch((error) => {
				dispatch(isLoading(false))
				console.error('Error loading dynamic filter options', error)
				return Promise.reject(error.response?.data?.Message || error.message)
			})
	}
}

/**
 * Download filtered critical components as Excel report
 * @param {object} filters - Same as loadAllCriticalComponentsDashboard
 * @returns {Promise<Blob>} - Resolves with the Excel file Blob
 */
export const downloadCriticalComponentsReport = (filters) => {
	return function (dispatch, getState) {
		dispatch(isSaving(true)) // Start saving/loading indicator
		let user = getState().oidc.user
		let config = getAuthorizedConfiguration(user)
		let url = `${window.config.serviceManagementBackendUrl}/CriticalComponents/Report`
		let command = {
			Years: filters?.year ?? [],
			Months: filters?.month ?? [],
			Models: filters?.model ?? [],
			Gaes: filters?.gae ?? [],
			Applicants: filters?.nomSol ?? [],
			MaterialPts: filters?.materialPt ?? [],
			Faults: filters?.fault ?? [],
			Failures: filters?.failure ?? [],
			CompletionDate: filters?.CompletionDate ?? ''
		}

		// Use 'arraybuffer' for Excel downloads, as in other actions
		const axiosConfig = { ...config, responseType: 'arraybuffer' }

		return axios
			.post(url, command, axiosConfig)
			.then((response) => {
				dispatch(isSaving(false)) // End saving/loading indicator
				return Promise.resolve(response.data) // This is an ArrayBuffer
			})
			.catch(async (error) => {
				dispatch(isSaving(false)) // End saving/loading indicator
				let errorMessage = 'Error downloading Critical Components report'
				try {
					if (error.response?.data instanceof ArrayBuffer) {
						// Try to decode the ArrayBuffer as text
						const decoder = new TextDecoder('utf-8')
						const text = decoder.decode(error.response.data)
						errorMessage = text || errorMessage
					}
				} catch (e) {
					// fallback to default error message
				}
				console.error(errorMessage, error)
				return Promise.reject(errorMessage)
			})
	}
}
